var map = {
	"./4D_Icon.svg": 427,
	"./4d-result-icon-white.svg": 958,
	"./4d-result-icon.svg": 415,
	"./93Connect_desktop.svg": 959,
	"./Add_Icon.svg": 171,
	"./All.svg": 960,
	"./Casino.svg": 961,
	"./Connect.svg": 962,
	"./Dashboard_Reward.svg": 418,
	"./FattyPay.svg": 963,
	"./FattyPay_DuitNow_Mobile.svg": 964,
	"./FattyPay_DuitNow_app.svg": 965,
	"./Fish Games.svg": 966,
	"./InCasino.svg": 967,
	"./InConnect.svg": 968,
	"./InLottery.svg": 969,
	"./InPoker.svg": 970,
	"./InRNG.svg": 971,
	"./InSlots.svg": 972,
	"./InSports.svg": 973,
	"./InVirtual-Sports.svg": 974,
	"./IneSports.svg": 975,
	"./Lottery.svg": 976,
	"./Minus_Icon.svg": 172,
	"./New-top-right.svg": 254,
	"./Poker.svg": 977,
	"./RNG.svg": 978,
	"./SPG.svg": 979,
	"./SPG_QR.svg": 980,
	"./SPG_QR_WH.svg": 981,
	"./SPG_QR_app.svg": 982,
	"./Slots.svg": 983,
	"./Sports.svg": 984,
	"./Truemoney_horizontal.svg": 985,
	"./Truemoney_vertical.svg": 986,
	"./VaderPay.svg": 987,
	"./VaderPay_QR.svg": 988,
	"./VaderPay_QR_WH.svg": 989,
	"./VaderPay_app.svg": 990,
	"./account-icon.svg": 991,
	"./android-icon.svg": 992,
	"./blue-background-modern.svg": 431,
	"./bonus-report-icon.svg": 993,
	"./cash-icon.svg": 994,
	"./cash-withdrawal-icon.svg": 995,
	"./commission-report-icon.svg": 996,
	"./contact-us-icon-yellow.svg": 284,
	"./contact-us-icon.svg": 997,
	"./copy-icon.svg": 998,
	"./custom-checkbox-1-checked.svg": 272,
	"./custom-checkbox-1-unchecked.svg": 273,
	"./custom-checkbox-modern-1-checked.svg": 432,
	"./custom-checkbox-modern-1-unchecked.svg": 433,
	"./dashboard-logout.svg": 262,
	"./downline-account.svg": 999,
	"./downline-icon-white.svg": 428,
	"./downline.svg": 1000,
	"./downlines-icon.svg": 416,
	"./eSports.svg": 1001,
	"./game-report-icon.svg": 1002,
	"./game.svg": 413,
	"./games-icon.svg": 1003,
	"./goldMinus.svg": 174,
	"./goldPlus.svg": 173,
	"./heart-all-icon.svg": 1004,
	"./hot-top-right.svg": 180,
	"./ionic-ios-add-circle-outline.svg": 169,
	"./ionic-ios-minus-circle-outline.svg": 170,
	"./kpi-icon.svg": 285,
	"./live-chat.svg": 1005,
	"./maintenance.svg": 434,
	"./mobile.svg": 429,
	"./money-bag.svg": 263,
	"./notification-icon-unread.svg": 421,
	"./notification-icon.svg": 422,
	"./phonebook-icon.svg": 1006,
	"./point-icon.svg": 1007,
	"./prize-package-icon.svg": 1008,
	"./provider-um-icon.svg": 1009,
	"./referral-icon.svg": 417,
	"./reload-icon-white.svg": 424,
	"./reload-icon.svg": 411,
	"./reports-icon-white.svg": 426,
	"./reports-icon.svg": 414,
	"./reset_password.svg": 181,
	"./result-icon.svg": 1010,
	"./right-menu-contact-us-icon.svg": 267,
	"./right-menu-home-icon.svg": 1011,
	"./right-menu-logout-icon.svg": 271,
	"./right-menu-notification-icon.svg": 264,
	"./right-menu-profile-icon.svg": 1012,
	"./right-menu-promotion-icon.svg": 208,
	"./right-menu-ranking-event-icon.svg": 270,
	"./right-menu-referral-icon.svg": 286,
	"./right-menu-settings-icon.svg": 269,
	"./right-menu-tnc-icon.svg": 268,
	"./right-menu-video-tutorial-icon.svg": 265,
	"./right-menu-vip-icon.svg": 266,
	"./right-menu-wallet-icon.svg": 1013,
	"./rollover-report-icon.svg": 1014,
	"./settings-icon.svg": 419,
	"./shareholder-icon.svg": 1015,
	"./star.svg": 420,
	"./ticket-icon.svg": 1016,
	"./tnc-icon.svg": 423,
	"./top-up-icon.svg": 1017,
	"./transfer-icon-white.svg": 425,
	"./transfer-icon.svg": 412,
	"./truepay.svg": 1018,
	"./truepayWhite.svg": 1019,
	"./under_maintenance.svg": 179,
	"./vid-tutorial-icon.svg": 283,
	"./wallet-stmt-icon.svg": 1020,
	"./wallet.svg": 1021,
	"./world_cup/diamond.svg": 1022,
	"./xmas-background-modern-lowerOpac.svg": 435,
	"./xmas-background-modern.svg": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 430;